<template>
  <registration-request-layout 
    :requestId="requestId"
    :onRequestProcessed="onRequestProcessed"
    :getRegistrationRequestById="workflowService.getLitterRegistrationById"
    :denyRegistrationRequest="workflowService.denyLitterRequest"
    :approveRegistrationRequest="workflowService.approveLitterRequest"
    :signSignatureByAdminFn="workflowService.signLitterRequestSignatureByAdmin"
    :markPaidByAdminFn="workflowService.markLitterPaidByAdmin"
    :setRegistrationData="(registration) => this.registration = registration"
  >  
    <v-alert v-if="!!registration && registration.isArtificialInsemination" type="warning">
          Sire’s collection information and <span v-html="artificialInseminationLink" /> must be on file with ASCA prior to approval of the litter.
          Check if forms have been sent to <span v-html="registrarEmailLink" />.
      </v-alert>
    <litter-registration-request :registration="registration" />
  </registration-request-layout>
</template>

<script lang="ts">
import Vue from 'vue';
import LitterRegistrationRequest from "@/components/Portal/MyRequest/LitterRegistrationRequest.vue";
import RegistrationRequestLayout from "@/components/common/RegistrationRequestLayout.vue";
import workflowService from "@/services/admin/workflowService";

import { LitterRegistration } from "@/constants";

export default Vue.extend({
  name: 'LitterRequestCard',
  props: {
    requestId: { type: Number },
  },
  components: {
    LitterRegistrationRequest,
    RegistrationRequestLayout
  },
  data: function() {
      return {
          registration: {
              workflowGuid: "",
              requestId: 0
          } as any,
        artificialInseminationLink: LitterRegistration.ArtificialInsemination_Link,
        registrarEmailLink: LitterRegistration.RegistrarEmail_Link,
      };
  },
  computed: {
    workflowService() {
      return workflowService;
    }
  },
  methods: {
    onRequestProcessed: function (requestId: number) {
      this.$navigate({ path: `/admin/registration/litters` });
    },
  }
});
</script>
